function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "hero_svg__a",
  width: "241.2%",
  height: "143%",
  x: "-70.6%",
  y: "-10.8%",
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "SourceGraphic",
  stdDeviation: 5
})), /*#__PURE__*/React.createElement("filter", {
  id: "hero_svg__b",
  width: "329.4%",
  height: "169.9%",
  x: "-114.7%",
  y: "-24.2%",
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feOffset", {
  dy: 30,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 22.5
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "shadowBlurOuter1",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
})), /*#__PURE__*/React.createElement("filter", {
  id: "hero_svg__e",
  width: "235.3%",
  height: "147.7%",
  x: "-67.6%",
  y: "-11.4%",
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "SourceGraphic",
  stdDeviation: 4
})), /*#__PURE__*/React.createElement("filter", {
  id: "hero_svg__f",
  width: "323.5%",
  height: "178.8%",
  x: "-111.8%",
  y: "-27%",
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feMorphology", {
  in: "SourceAlpha",
  operator: "dilate",
  radius: 0.5,
  result: "shadowSpreadOuter1"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 30,
  in: "shadowSpreadOuter1",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feMorphology", {
  in: "SourceAlpha",
  radius: 1,
  result: "shadowInner"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 30,
  in: "shadowInner",
  result: "shadowInner"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "shadowOffsetOuter1",
  in2: "shadowInner",
  operator: "out",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 22.5
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "shadowBlurOuter1",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
})), /*#__PURE__*/React.createElement("filter", {
  id: "hero_svg__i",
  width: "294.1%",
  height: "155.4%",
  x: "-97.1%",
  y: "-17.6%",
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feOffset", {
  dy: 30,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 22.5
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "shadowBlurOuter1",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
})), /*#__PURE__*/React.createElement("filter", {
  id: "hero_svg__l",
  width: "248.2%",
  height: "177.3%",
  x: "-74.1%",
  y: "-38.7%",
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "SourceGraphic",
  stdDeviation: 6
})), /*#__PURE__*/React.createElement("filter", {
  id: "hero_svg__m",
  width: "301.2%",
  height: "204.9%",
  x: "-100.6%",
  y: "-52.5%",
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feOffset", {
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 22.5
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "shadowBlurOuter1",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
})), /*#__PURE__*/React.createElement("filter", {
  id: "hero_svg__p",
  width: "295.3%",
  height: "172.8%",
  x: "-97.6%",
  y: "-23.2%",
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feMorphology", {
  in: "SourceAlpha",
  operator: "dilate",
  radius: 0.5,
  result: "shadowSpreadOuter1"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 30,
  in: "shadowSpreadOuter1",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feMorphology", {
  in: "SourceAlpha",
  radius: 1,
  result: "shadowInner"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 30,
  in: "shadowInner",
  result: "shadowInner"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "shadowOffsetOuter1",
  in2: "shadowInner",
  operator: "out",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 22.5
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "shadowBlurOuter1",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
})), /*#__PURE__*/React.createElement("filter", {
  id: "hero_svg__r",
  width: "241.2%",
  height: "135%",
  x: "-70.6%",
  y: "-8.7%",
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "SourceGraphic",
  stdDeviation: 5
})), /*#__PURE__*/React.createElement("filter", {
  id: "hero_svg__s",
  width: "329.4%",
  height: "156.9%",
  x: "-114.7%",
  y: "-19.7%",
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feOffset", {
  dy: 30,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 22.5
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "shadowBlurOuter1",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
})), /*#__PURE__*/React.createElement("filter", {
  id: "hero_svg__v",
  width: "294.1%",
  height: "148.1%",
  x: "-97.1%",
  y: "-15.3%",
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feOffset", {
  dy: 30,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 22.5
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "shadowBlurOuter1",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
})), /*#__PURE__*/React.createElement("filter", {
  id: "hero_svg__x",
  width: "235.3%",
  height: "138.1%",
  x: "-67.6%",
  y: "-9.1%",
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "SourceGraphic",
  stdDeviation: 4
})), /*#__PURE__*/React.createElement("filter", {
  id: "hero_svg__y",
  width: "323.5%",
  height: "162.9%",
  x: "-111.8%",
  y: "-21.5%",
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feMorphology", {
  in: "SourceAlpha",
  operator: "dilate",
  radius: 0.5,
  result: "shadowSpreadOuter1"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 30,
  in: "shadowSpreadOuter1",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feMorphology", {
  in: "SourceAlpha",
  radius: 1,
  result: "shadowInner"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 30,
  in: "shadowInner",
  result: "shadowInner"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "shadowOffsetOuter1",
  in2: "shadowInner",
  operator: "out",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 22.5
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "shadowBlurOuter1",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
})), /*#__PURE__*/React.createElement("filter", {
  id: "hero_svg__B",
  width: "248.2%",
  height: "180.3%",
  x: "-74.1%",
  y: "-40.1%",
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "SourceGraphic",
  stdDeviation: 6
})), /*#__PURE__*/React.createElement("filter", {
  id: "hero_svg__C",
  width: "301.2%",
  height: "208.9%",
  x: "-100.6%",
  y: "-54.5%",
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feOffset", {
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 22.5
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "shadowBlurOuter1",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
})), /*#__PURE__*/React.createElement("filter", {
  id: "hero_svg__F",
  width: "295.3%",
  height: "155%",
  x: "-97.6%",
  y: "-17.5%",
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feMorphology", {
  in: "SourceAlpha",
  operator: "dilate",
  radius: 0.5,
  result: "shadowSpreadOuter1"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 30,
  in: "shadowSpreadOuter1",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feMorphology", {
  in: "SourceAlpha",
  radius: 1,
  result: "shadowInner"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 30,
  in: "shadowInner",
  result: "shadowInner"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "shadowOffsetOuter1",
  in2: "shadowInner",
  operator: "out",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 22.5
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "shadowBlurOuter1",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
})), /*#__PURE__*/React.createElement("filter", {
  id: "hero_svg__H",
  width: "241.2%",
  height: "179.5%",
  x: "-70.6%",
  y: "-19.9%",
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "SourceGraphic",
  stdDeviation: 5
})), /*#__PURE__*/React.createElement("filter", {
  id: "hero_svg__I",
  width: "329.4%",
  height: "229.1%",
  x: "-114.7%",
  y: "-44.7%",
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feOffset", {
  dy: 30,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 22.5
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "shadowBlurOuter1",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
})), /*#__PURE__*/React.createElement("filter", {
  id: "hero_svg__L",
  width: "235.3%",
  height: "291.7%",
  x: "-67.6%",
  y: "-45.8%",
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "SourceGraphic",
  stdDeviation: 4
})), /*#__PURE__*/React.createElement("filter", {
  id: "hero_svg__M",
  width: "323.5%",
  height: "416.7%",
  x: "-111.8%",
  y: "-108.3%",
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feMorphology", {
  in: "SourceAlpha",
  operator: "dilate",
  radius: 0.5,
  result: "shadowSpreadOuter1"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 30,
  in: "shadowSpreadOuter1",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feMorphology", {
  in: "SourceAlpha",
  radius: 1,
  result: "shadowInner"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 30,
  in: "shadowInner",
  result: "shadowInner"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "shadowOffsetOuter1",
  in2: "shadowInner",
  operator: "out",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 22.5
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "shadowBlurOuter1",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
})), /*#__PURE__*/React.createElement("filter", {
  id: "hero_svg__P",
  width: "294.1%",
  height: "209.3%",
  x: "-97.1%",
  y: "-34.8%",
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feOffset", {
  dy: 30,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 22.5
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "shadowBlurOuter1",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
})), /*#__PURE__*/React.createElement("filter", {
  id: "hero_svg__R",
  width: "248.2%",
  height: "280%",
  x: "-74.1%",
  y: "-90%",
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "SourceGraphic",
  stdDeviation: 6
})), /*#__PURE__*/React.createElement("filter", {
  id: "hero_svg__S",
  width: "301.2%",
  height: "344.3%",
  x: "-100.6%",
  y: "-122.1%",
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feOffset", {
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 22.5
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "shadowBlurOuter1",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
})), /*#__PURE__*/React.createElement("filter", {
  id: "hero_svg__V",
  width: "295.3%",
  height: "376.7%",
  x: "-97.6%",
  y: "-88.3%",
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feMorphology", {
  in: "SourceAlpha",
  operator: "dilate",
  radius: 0.5,
  result: "shadowSpreadOuter1"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 30,
  in: "shadowSpreadOuter1",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feMorphology", {
  in: "SourceAlpha",
  radius: 1,
  result: "shadowInner"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 30,
  in: "shadowInner",
  result: "shadowInner"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "shadowOffsetOuter1",
  in2: "shadowInner",
  operator: "out",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 22.5
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "shadowBlurOuter1",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
})), /*#__PURE__*/React.createElement("filter", {
  id: "hero_svg__Y",
  width: "126%",
  height: "300%",
  x: "-13%",
  y: "-100%",
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "SourceGraphic",
  stdDeviation: 20
})), /*#__PURE__*/React.createElement("rect", {
  id: "hero_svg__c",
  width: 85,
  height: 279,
  x: 0,
  y: 18,
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  id: "hero_svg__g",
  width: 85,
  height: 241,
  x: 10,
  y: 352,
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  id: "hero_svg__j",
  width: 85,
  height: 298,
  x: 0,
  y: 0,
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  id: "hero_svg__n",
  width: 85,
  height: 163,
  x: 0,
  y: 316,
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  id: "hero_svg__q",
  width: 85,
  height: 228,
  x: 20,
  y: 33,
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  id: "hero_svg__t",
  width: 85,
  height: 343,
  x: 10,
  y: 0,
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  id: "hero_svg__w",
  width: 85,
  height: 343,
  x: 10,
  y: 1,
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  id: "hero_svg__z",
  width: 85,
  height: 302,
  x: 0,
  y: 361,
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  id: "hero_svg__D",
  width: 85,
  height: 157,
  x: 10,
  y: 362,
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  id: "hero_svg__G",
  width: 85,
  height: 302,
  x: 0,
  y: 32,
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  id: "hero_svg__J",
  width: 85,
  height: 151,
  x: 5,
  y: 14,
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  id: "hero_svg__N",
  width: 85,
  height: 60,
  x: 0,
  y: 318,
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  id: "hero_svg__Q",
  width: 85,
  height: 151,
  x: 5,
  y: 14,
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  id: "hero_svg__T",
  width: 85,
  height: 70,
  x: 5,
  y: 228,
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  id: "hero_svg__W",
  width: 85,
  height: 60,
  x: 0,
  y: 0,
  rx: 1
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__d",
  x1: "50%",
  x2: "50%",
  y1: "0%",
  y2: "100%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#7A3390"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#512D93"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__h",
  x1: "50%",
  x2: "50%",
  y1: "69.927%",
  y2: "100%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#793390",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#7A3390"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__k",
  x1: "50%",
  x2: "50%",
  y1: "0%",
  y2: "100%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#7A3390"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#512D93"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__o",
  x1: "50%",
  x2: "50%",
  y1: "0%",
  y2: "100%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#7A3390",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#512D93"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__u",
  x1: "50%",
  x2: "50%",
  y1: "0%",
  y2: "100%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#23C386"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#2A8F9D"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__A",
  x1: "50%",
  x2: "50%",
  y1: "69.927%",
  y2: "100%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#49DFBD",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#23BB88"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__E",
  x1: "50%",
  x2: "50%",
  y1: "0%",
  y2: "100%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#23C386",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#2A8F9D"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__K",
  x1: "50%",
  x2: "50%",
  y1: "0%",
  y2: "100%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#285D99"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#2E3195"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__O",
  x1: "50%",
  x2: "50%",
  y1: "0%",
  y2: "100%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#5483C9",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#2A4C98"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__U",
  x1: "50%",
  x2: "50%",
  y1: "0%",
  y2: "100%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#285D99",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#2E3195"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__X",
  x1: "0%",
  x2: "100%",
  y1: "50%",
  y2: "50%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#23C386",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: "25.811%",
  stopColor: "#23C386"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "49.653%",
  stopColor: "#2E3195"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "74.642%",
  stopColor: "#512D93"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#512D93",
  stopOpacity: 0
})));

var _ref2 = /*#__PURE__*/React.createElement("use", {
  fill: "#000",
  filter: "url(#hero_svg__b)",
  xlinkHref: "#hero_svg__c"
});

var _ref3 = /*#__PURE__*/React.createElement("use", {
  fill: "url(#hero_svg__d)",
  xlinkHref: "#hero_svg__c"
});

var _ref4 = /*#__PURE__*/React.createElement("use", {
  fill: "#000",
  filter: "url(#hero_svg__f)",
  xlinkHref: "#hero_svg__g"
});

var _ref5 = /*#__PURE__*/React.createElement("use", {
  stroke: "url(#hero_svg__h)",
  xlinkHref: "#hero_svg__g"
});

var _ref6 = /*#__PURE__*/React.createElement("g", {
  transform: "matrix(-1 0 0 1 383 60)"
}, /*#__PURE__*/React.createElement("use", {
  fill: "#000",
  filter: "url(#hero_svg__i)",
  xlinkHref: "#hero_svg__j"
}), /*#__PURE__*/React.createElement("use", {
  fill: "url(#hero_svg__k)",
  xlinkHref: "#hero_svg__j"
}));

var _ref7 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#hero_svg__l)",
  opacity: 0.312,
  transform: "rotate(180 191.5 427.5)"
}, /*#__PURE__*/React.createElement("use", {
  fill: "#000",
  filter: "url(#hero_svg__m)",
  xlinkHref: "#hero_svg__n"
}), /*#__PURE__*/React.createElement("use", {
  fill: "url(#hero_svg__o)",
  xlinkHref: "#hero_svg__n"
}));

var _ref8 = /*#__PURE__*/React.createElement("use", {
  fill: "#000",
  filter: "url(#hero_svg__p)",
  xlinkHref: "#hero_svg__q"
});

var _ref9 = /*#__PURE__*/React.createElement("use", {
  stroke: "#793390",
  xlinkHref: "#hero_svg__q"
});

var _ref10 = /*#__PURE__*/React.createElement("use", {
  fill: "#000",
  filter: "url(#hero_svg__s)",
  xlinkHref: "#hero_svg__t"
});

var _ref11 = /*#__PURE__*/React.createElement("use", {
  fill: "url(#hero_svg__u)",
  xlinkHref: "#hero_svg__t"
});

var _ref12 = /*#__PURE__*/React.createElement("use", {
  fill: "#000",
  filter: "url(#hero_svg__v)",
  xlinkHref: "#hero_svg__w"
});

var _ref13 = /*#__PURE__*/React.createElement("use", {
  fill: "url(#hero_svg__u)",
  xlinkHref: "#hero_svg__w"
});

var _ref14 = /*#__PURE__*/React.createElement("use", {
  fill: "#000",
  filter: "url(#hero_svg__y)",
  xlinkHref: "#hero_svg__z"
});

var _ref15 = /*#__PURE__*/React.createElement("use", {
  stroke: "url(#hero_svg__A)",
  xlinkHref: "#hero_svg__z"
});

var _ref16 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#hero_svg__B)",
  opacity: 0.312,
  transform: "matrix(1 0 0 -1 0 881)"
}, /*#__PURE__*/React.createElement("use", {
  fill: "#000",
  filter: "url(#hero_svg__C)",
  xlinkHref: "#hero_svg__D"
}), /*#__PURE__*/React.createElement("use", {
  fill: "url(#hero_svg__E)",
  xlinkHref: "#hero_svg__D"
}));

var _ref17 = /*#__PURE__*/React.createElement("use", {
  fill: "#000",
  filter: "url(#hero_svg__F)",
  xlinkHref: "#hero_svg__G"
});

var _ref18 = /*#__PURE__*/React.createElement("use", {
  stroke: "#23BB88",
  xlinkHref: "#hero_svg__G"
});

var _ref19 = /*#__PURE__*/React.createElement("use", {
  fill: "#000",
  filter: "url(#hero_svg__I)",
  xlinkHref: "#hero_svg__J"
});

var _ref20 = /*#__PURE__*/React.createElement("use", {
  fill: "url(#hero_svg__K)",
  xlinkHref: "#hero_svg__J"
});

var _ref21 = /*#__PURE__*/React.createElement("use", {
  fill: "#000",
  filter: "url(#hero_svg__M)",
  xlinkHref: "#hero_svg__N"
});

var _ref22 = /*#__PURE__*/React.createElement("use", {
  stroke: "url(#hero_svg__O)",
  xlinkHref: "#hero_svg__N"
});

var _ref23 = /*#__PURE__*/React.createElement("g", {
  transform: "matrix(-1 0 0 1 283 172)"
}, /*#__PURE__*/React.createElement("use", {
  fill: "#000",
  filter: "url(#hero_svg__P)",
  xlinkHref: "#hero_svg__Q"
}), /*#__PURE__*/React.createElement("use", {
  fill: "url(#hero_svg__K)",
  xlinkHref: "#hero_svg__Q"
}));

var _ref24 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#hero_svg__R)",
  opacity: 0.573,
  transform: "rotate(180 141.5 349)"
}, /*#__PURE__*/React.createElement("use", {
  fill: "#000",
  filter: "url(#hero_svg__S)",
  xlinkHref: "#hero_svg__T"
}), /*#__PURE__*/React.createElement("use", {
  fill: "url(#hero_svg__U)",
  xlinkHref: "#hero_svg__T"
}));

var _ref25 = /*#__PURE__*/React.createElement("use", {
  fill: "#000",
  filter: "url(#hero_svg__V)",
  xlinkHref: "#hero_svg__W"
});

var _ref26 = /*#__PURE__*/React.createElement("use", {
  stroke: "#2A4C98",
  xlinkHref: "#hero_svg__W"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__X)",
  d: "M0 410l231-60 231 60H0z",
  filter: "url(#hero_svg__Y)",
  opacity: 0.361,
  transform: "matrix(1 0 0 -1 15 774)"
});

function SvgHero(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 492 666"
  }, props), _ref, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    filter: "url(#hero_svg__a)",
    transform: "matrix(-1 0 0 1 383 60)"
  }, _ref2, _ref3), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    filter: "url(#hero_svg__e)",
    transform: "matrix(1 0 0 -1 298 1005)"
  }, _ref4, _ref5), _ref6, _ref7, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    transform: "translate(298 60)"
  }, _ref8, _ref9), /*#__PURE__*/React.createElement("g", {
    transform: "translate(78 14)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    filter: "url(#hero_svg__r)"
  }, _ref10, _ref11), _ref12, _ref13, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    filter: "url(#hero_svg__x)",
    transform: "matrix(1 0 0 -1 0 1024)"
  }, _ref14, _ref15), _ref16, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _ref17, _ref18)), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    filter: "url(#hero_svg__H)",
    transform: "matrix(-1 0 0 1 283 172)"
  }, _ref19, _ref20), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    filter: "url(#hero_svg__L)",
    transform: "matrix(1 0 0 -1 188 868)"
  }, _ref21, _ref22), _ref23, _ref24, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    transform: "translate(188 172)"
  }, _ref25, _ref26), _ref27));
}

export default __webpack_public_path__ + "static/hero.37bca6d4.svg";
export { SvgHero as ReactComponent };